/* como funciona e jogos compativeis na home nova (secoes nt-fx-como-funciona e nt-fx-jogos).
   o arquivo pode vir em mais de uma secao da pagina: so a primeira execucao vale. */
(function () {
  'use strict';
  if (window.ntFxG2) return;
  window.ntFxG2 = true;

  var reduz = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* numeros: contam de zero ate o valor quando aparecem na tela. o html ja traz o valor final
     (leitor de tela e quem nao roda script veem o numero certo); o desenho do titulo vem do
     data-texto, entao ele anda junto com o texto */
  function contar(el) {
    var alvo = Number(el.getAttribute('data-g2-conta'));
    if (!(alvo > 0) || alvo % 1) return;
    var sufixo = el.getAttribute('data-g2-sufixo') || '';
    var atraso = Number(el.getAttribute('data-g2-atraso')) || 0;
    var duracao = 3200;
    var inicio = performance.now() + atraso;
    function mostra(v) {
      var t = v + sufixo;
      el.textContent = t;
      el.setAttribute('data-texto', t);
    }
    mostra(0);
    requestAnimationFrame(function passo(agora) {
      if (agora < inicio) return requestAnimationFrame(passo);
      var p = Math.min(1, (agora - inicio) / duracao);
      mostra(Math.round(alvo * (1 - Math.pow(1 - p, 5))));
      if (p < 1) requestAnimationFrame(passo);
    });
  }

  function iniciarNumeros(raiz) {
    var els = raiz.querySelectorAll('[data-g2-conta]:not([data-g2-ok])');
    if (!els.length || reduz.matches || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (itens) {
      itens.forEach(function (it) {
        if (!it.isIntersecting) return;
        io.unobserve(it.target);
        contar(it.target);
      });
    }, { threshold: 0.3 });
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-g2-ok', '');
      io.observe(el);
    });
  }

  /* player: depois do clique o botao vira o iframe do youtube; o foco vai para ele */
  document.addEventListener('click', function (e) {
    var botao = e.target.closest && e.target.closest('.s-como-funciona [data-nt-play]');
    if (!botao) return;
    var tela = botao.closest('nt-video');
    setTimeout(function () {
      var quadro = tela && tela.querySelector('iframe');
      if (quadro) quadro.focus();
    }, 0);
  }, true);

  /* esteira de jogos: a velocidade do editor e em pixels por segundo, entao a duracao da volta
     sai da largura real da lista. se a tela for mais larga que a lista, entram mais copias.
     o passo do mascote tem tempo proprio (mascote_duracao) e nao muda com a velocidade da esteira */
  function ajustarEsteira(sec) {
    if (reduz.matches) return;
    var pista = sec.querySelector('.s-jogos__pista');
    var esteira = sec.querySelector('.s-jogos__esteira');
    var trilho = esteira && esteira.querySelector('.s-jogos__trilho');
    var largura = trilho ? trilho.offsetWidth : 0;
    if (!largura) return;
    var velocidade = Number(sec.getAttribute('data-velocidade')) || 100;
    sec.style.setProperty('--jogos-tempo', (largura / velocidade).toFixed(2) + 's');
    var precisa = Math.ceil(pista.offsetWidth / largura) + 1;
    var ultimo = esteira.lastElementChild;
    while (esteira.children.length < precisa) {
      var copia = ultimo.cloneNode(true);
      copia.setAttribute('aria-hidden', 'true');
      esteira.appendChild(copia);
    }
  }

  /* pausa: o botao do canto para e volta a esteira no toque e no teclado (o mouse em cima ja parava) */
  function ligarPausa(sec) {
    var botao = sec.querySelector('[data-jogos-pausa]');
    if (!botao || botao.ntG2) return;
    botao.ntG2 = true;
    botao.hidden = false;
    botao.addEventListener('click', function () {
      var parada = botao.getAttribute('aria-pressed') !== 'true';
      botao.setAttribute('aria-pressed', String(parada));
      sec.classList.toggle('is-pausada', parada);
    });
  }

  function iniciarJogos(raiz) {
    var secoes = raiz.matches && raiz.matches('.s-jogos') ? [raiz] : raiz.querySelectorAll('.s-jogos');
    Array.prototype.forEach.call(secoes, function (sec) {
      ligarPausa(sec);
      ajustarEsteira(sec);
      if (!('ResizeObserver' in window) || sec.ntG2Ro) return;
      var ultimaLargura = 0;
      var pedido = 0;
      sec.ntG2Ro = new ResizeObserver(function () {
        if (sec.offsetWidth === ultimaLargura) return;
        ultimaLargura = sec.offsetWidth;
        cancelAnimationFrame(pedido);
        pedido = requestAnimationFrame(function () { ajustarEsteira(sec); });
      });
      sec.ntG2Ro.observe(sec);
    });
  }

  function iniciar(raiz) {
    iniciarNumeros(raiz);
    iniciarJogos(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(document); }, { once: true });
  } else {
    iniciar(document);
  }
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
